import { render, staticRenderFns } from "./MessageService.vue?vue&type=template&id=40c770dc&"
import script from "./MessageService.vue?vue&type=script&lang=js&"
export * from "./MessageService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports